import React, { useEffect, useRef, useState } from 'react';

type Props = {
  subject: string;
};

export const SubjectRow: React.FC<Props> = ({ subject }): JSX.Element => {
  const [showTooltip, setShowTooltip] = useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const subjRef = useRef<HTMLDivElement>(null);

  const handleShowTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;
    const isSubjectTarget = subjRef.current?.contains(target);
    if (!isSubjectTarget && showTooltip) setShowTooltip(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () =>
      document.removeEventListener('click', handleClickOutside, true);
  });

  const emailSubject =
    subject?.length && subject.split(':').length > 1
      ? subject.split(':')[1]
      : subject;

  const hasTooltipCheck = () => {
    let isTooltip = false;
    if (wrapperRef.current?.offsetWidth && subjRef.current?.offsetWidth) {
      if (wrapperRef.current.offsetWidth === subjRef.current.offsetWidth + 20) {
        isTooltip = true;
      }
    }

    return isTooltip;
  };

  const attrs = {
    wrapper: {
      className: 'subj-row',
      ref: wrapperRef,
    },
    text: {
      className: 'subj-row-text',
      onMouseEnter: handleShowTooltip,
      onMouseLeave: handleShowTooltip,
      ref: subjRef,
    },
    tooltip: {
      wrapper: {
        className:
          showTooltip && hasTooltipCheck()
            ? 'open subj-row__toltip'
            : 'subj-row__toltip',
      },
    },
  };

  const getCoordinatesForTooltip = () => {
    let xCoord = '';
    let yCoord = '';
    if (subjRef?.current?.getClientRects()?.length) {
      const { x, y } = subjRef.current.getClientRects()[0];
      xCoord = `${x}px`;
      yCoord = `${y + 10}px`;
    }
    return { xCoord, yCoord };
  };

  const { xCoord, yCoord } = getCoordinatesForTooltip();

  const subjectTooltip = (
    <span
      {...attrs.tooltip.wrapper}
      style={
        showTooltip && yCoord && xCoord
          ? { position: 'fixed', top: yCoord, left: xCoord }
          : {}
      }
    >
      {emailSubject}
    </span>
  );

  return (
    <div {...attrs.wrapper}>
      {subjectTooltip}
      <span {...attrs.text}>{emailSubject}</span>
    </div>
  );
};
